import React         from 'react';
import { Redirect }  from 'react-router-dom';
import QuizList      from './QuizList';
import QuizBuilder   from './quizBuilder/QuizBuilder';
import QuizViewer    from './quizViewer/QuizViewer';
import QuizScore     from './quizScore/QuizScore';
import QuizGrader    from './quizGrader/QuizGrader';
import HotSpotAnswer from './quizBuilder/questionType/HotSpotAnswer';

export const QuizConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/quiz/debug_map',
            component : HotSpotAnswer,
        },
        {
            path      : '/quiz/test/:quiz_id',
            component : QuizViewer,
            permission: { component_name: 'quiz', permission_type: 'grade' },
        },
        {
            path      : '/quiz/student/:event_id',
            component : QuizViewer,
            permission: { component_name: 'quiz', permission_type: 'student' },
        },
        {
            path      : '/quiz/score/:student_quiz_id',
            component : QuizScore,
        },
        {
            path      : '/quiz/grader/:student_quiz_id',
            component : QuizGrader,
            permission: { component_name: 'quiz', permission_type: 'grade' },
        },
        {
            path      : '/quiz/:view_type/:quiz_id',
            component : QuizBuilder,
            permission: { component_name: 'quiz', permission_type: 'view_type' },
        },
        {
            path      : '/quiz/list',
            component : QuizList,
            permission: { component_name: 'quiz', permission_type: 'list' },
        },
        {
            path      : '/quiz/:view_type/',
            component : QuizBuilder,
            permission: { component_name: 'quiz', permission_type: 'view_type' },
        },
        {
            path      : '/quiz',
            component : () => <Redirect to="/quiz/list"/>,
            permission: { component_name: 'quiz', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/quiz/QuizConfig.js